var App = App || {};

App.RatesBand = (function ($) {
    "use strict";

    function init() {

        const ratesBands = $(".block.block-rates-band");
        if (ratesBands.length) {
            ratesBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(ratesBand) {
        const carousel = ratesBand.find(".rate-cards-list.splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: true,
                type: 'loop',
                fixedWidth: "17.3rem",
                gap: "80px",
                drag: true,
                snap: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        fixedWidth: "13rem",
                        gap: "25px",
                        perMove: 2,
                        perPage: 2,
                    },
                }
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RatesBand.init();
});